import { render } from "./mfa-challenge.vue?vue&type=template&id=4f55dab8"
import script from "./mfa-challenge.vue?vue&type=script&lang=js"
export * from "./mfa-challenge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__